import isEmpty from 'lodash/isEmpty';
import { memo, useMemo } from 'react';

import { publicRuntimeConfig } from 'lib/utils/Environment';
import HeadContent from 'shared/components/_oneflare/HeadContent/HeadContent';
import CallSalesCTASection from 'shared/components/CallSalesCTASection';
import Footer from 'shared/components/Footer';
import LazyLoadedSection from 'shared/components/LazyLoadedSection';
import Navigation from 'shared/components/Navigation';
import PageHeader from 'shared/components/PageHeader/PageHeader';
import RegisterBusinessCTASection from 'shared/components/RegisterBusinessCTASection';
import { CONTENT_HUB_WP_PATH } from 'shared/utils/constants';
import type { BusinessCentrePageProps } from 'types/oneflare.com.au/businessCentre';
import type { IGetAllPostsQueryDataModel } from 'types/shared';

import ArticleItem from './components/ArticleItem';
import { CategorySectionStyled, CategoryHeaderStyled, CategorySubTitle, CategoryContentStyled } from './styled/Category';

const Category = ({
  params,
  pageUrl,
  getAllPost, 
  getCategoryWithParentData: {
    getCategory: topLevelCategoryData
  },
  getCategoryData: {
    getCategory: pageCategory
  }
}: BusinessCentrePageProps & IGetAllPostsQueryDataModel) => {
  const { staticRender } = params;
  const [getCategoryPrefix] = pageCategory;
  const pageTitle = getCategoryPrefix?.acf?.categorySetup?.pageTitle;
  const metaDescription = getCategoryPrefix?.acf.categorySetup?.metaDescription;
  const categoryTitle = getCategoryPrefix?.name;
  const heroIntro = getCategoryPrefix?.acf?.heroSetup?.intro;
  const postsList = useMemo(() => getAllPost?.map(({ acf, link, title }) => {
    const pageSetup = acf?.pageSetup;
    const thumbnail = pageSetup?.thumbnail?.sizes?.medium;
    const altText = pageSetup?.thumbnail?.alt;
    const { articleExcerpt } = pageSetup;
    return {
      thumbnail,
      title: title?.rendered,
      url: link?.replace(CONTENT_HUB_WP_PATH, ''),
      articleExcerpt,
      altText
    };
  }), [getAllPost]);

  return (
    <>
      <HeadContent
        pageUrl={`${publicRuntimeConfig.SITE_URL}${pageUrl}`}
        pageTitle={pageTitle}
        metaDescription={metaDescription}
      />
      <PageHeader hideStickyHeader />
      <Navigation data={topLevelCategoryData} className="smUp" pageName="Business centre" path="business-centre" />
      <CategorySectionStyled>
        <CategoryHeaderStyled>{categoryTitle.replace(/&amp;/g, '&')}</CategoryHeaderStyled>
        <Navigation data={topLevelCategoryData} className="smDown" pageName="Business centre" path="business-centre" />
        <CategorySubTitle>{heroIntro}</CategorySubTitle>
        <CategoryContentStyled>
          {!isEmpty(postsList) && postsList.map((item) => (
            <ArticleItem
              key={item.title}
              item={item}
            />
          ))}
        </CategoryContentStyled>
      </CategorySectionStyled>
      <LazyLoadedSection autoLoad={staticRender}>
        <CallSalesCTASection />
      </LazyLoadedSection>
      <LazyLoadedSection style={{ minHeight: '218px' }} autoLoad={staticRender}>
        <RegisterBusinessCTASection />
      </LazyLoadedSection>
      <LazyLoadedSection style={{ minHeight: '218px' }} autoLoad={staticRender}>
        <Footer />
      </LazyLoadedSection>
    </>
  );
};

export default memo(Category);
